import { apiInstance, legacyV3Path } from '../index'

const requestApiToken = {
  create (companyId, data) {
    return apiInstance({
      method: 'POST',
      url: `${legacyV3Path()}/requestApiToken/${companyId}`,
      data
    })
  }
}

export default requestApiToken
